/* Shared sort / colour-filter helpers for every catalogue grid
   (HQ catalogue, VIP Build-a-Box, Choose My Tubers, public catalogue). */

export const SORT_OPTIONS = [
  { v: "az", label: "Name A to Z" },
  { v: "za", label: "Name Z to A" },
  { v: "newest", label: "Newest first" },
];

/* Simplified colour families , checked in order, first match wins. */
const COLOUR_GROUPS = [
  { label: "Muted pinks", rx: /muted|dusky|dusty|blush|antique|soft pink|pale pink|powder/ },
  { label: "Peach", rx: /peach|apricot|salmon|coral/ },
  { label: "Orange", rx: /orange|rust|amber|bronze|tangerine|copper|flame/ },
  { label: "Yellow", rx: /yellow|gold|lemon|butter|primrose/ },
  { label: "Purples", rx: /purple|lilac|lavender|mauve|plum|violet|magenta|burgundy|wine|aubergine/ },
  { label: "Pinks", rx: /pink|rose|raspberry|fuchsia|cerise|watermelon|candy/ },
];

function colourGroup(raw) {
  const c = (raw || "").trim().toLowerCase();
  if (!c) return null;
  for (const g of COLOUR_GROUPS) if (g.rx.test(c)) return g.label;
  return "Other";
}

export function distinctColours(list) {
  const present = new Set();
  (list || []).forEach((v) => {
    const g = colourGroup(v.colour);
    if (g) present.add(g);
  });
  const ordered = COLOUR_GROUPS.map((g) => g.label).filter((l) => present.has(l));
  if (present.has("Other")) ordered.push("Other");
  return ordered;
}

export function applyCatalogControls(list, { q = "", sort = "az", colour = "all" } = {}) {
  const term = q.trim().toLowerCase();
  let out = [...(list || [])];
  if (term) {
    out = out.filter(
      (v) => (v.name || "").toLowerCase().includes(term) || (v.colour || "").toLowerCase().includes(term)
    );
  }
  if (colour && colour !== "all") {
    out = out.filter((v) => (colourGroup(v.colour) || "").toLowerCase() === colour.toLowerCase());
  }
  if (sort === "za") out.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
  else if (sort === "newest") out.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
  else out.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  return out;
}
